<template>
  <div>
  </div>
</template>


<script>
import pageMixin from '@/mixins/page.mixin'


export default {
  mixins: [
    pageMixin
  ],


  async created () {
    this.setPageTitle(this.$t('nav.dashboard'))
    this.stopPageLoading()
  }
}
</script>
